<template>
  <div id="hrms41e-detail-tab2" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab2">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRMS41EC2']['70'] }}
      </h3>
    </div>
    <div id="tab2" class="panel-collapse collapse tab-detail">
      <div class="panel-body">   
          <div class="detail detail-responsive panel-detail-filter">
              <hrms-table 
                :columns="detailTab2Columns" 
                :data="detailTab2"
                :searchDisp="false" />
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hrms41e-detail-tab2',
  props: [ 'labels', 'detailTab2', 'labelsButton', 'indexSelected', 'detailTab2Columns' ]
}
</script>


// WEBPACK FOOTER //
// detailTab2.vue?2f457e4a